// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from '@configs/axios'
import axiosRetry from 'axios-retry'
export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
   // const axiosSend = axios.get('/fetchUser')
    axiosRetry(axios, { retries: 3 })
  return axios.get('/user/profile')

    .then(res => {
        localStorage.setItem('fetchUser', JSON.stringify(res.data.data))
      return {
          data: res.data.data
      }
    })
    .catch(err => {
        return {
          data: {}
        }
    })
})

export const FetchUserSlice = createSlice({
    name: 'user',
    initialState: {
      user: {},
      socket:""
    },
    reducers: {
    },
    extraReducers: builder => {
      builder
        .addCase(fetchUser.fulfilled, (state, action) => {
            state.user = action.payload.data
        })
    }
  })

export const { handleFetchUserData } = FetchUserSlice.actions

export default FetchUserSlice.reducer
